export default __webpack_public_path__ + "static/media/DISS-CO_SIP_Data Protection and Security FAQ_20240208.9dac5810.pdf";